import React from 'react'
import { Translation, Translator } from '@morningtrain/react-translations'
import Smartview from 'widgets/smartviews/Smartview'
import * as UI from 'ui'
import EmploymentActions from 'widgets/employments/EmploymentActions'

export default function EmploymentSmartviewWrapper ({
  children,
  size = 'xs',
  create = false,
  isEdit = false,
  showFooter = false,
}) {
  const footer = () => {
    if (!showFooter) {
      return null
    }

    return (
            <UI.ButtonWrap grow>
              <EmploymentActions isEdit={isEdit}/>
            </UI.ButtonWrap>
    )
  }

  return (
          <Translator namespace="hr.employments">
            <Smartview
                    size={size}
                    header={create === false ? null : <Translation name="titles.create"/>}
                    footer={footer()}
            >
              {children}
            </Smartview>
          </Translator>
  )
}
